<script>
    console.log("Initializing App")

    import PersonDataInput from "./PersonDataInput.svelte"
    import AgeOutput from "./AgeOutput.svelte"
    import Head from "./Head.svelte"
    import { onMount, afterUpdate } from "svelte"
    import { subscribe } from "svelte/internal"
    import { now } from "./timer"
    import dayjs from "dayjs"
    import * as animateScroll from "svelte-scrollto"

    const dateUnits = ["day", "month", "year"]
    const ageUnits = ["years", "months", "days", "hours", "minutes", "seconds"]
    let name = null
    let birthday = {}

    let inputDom
    let outputDom

    const difference = (from, to) => {
        console.log("calculating difference.", from, to)

        const diff = {}

        ageUnits.forEach(unit => (diff[unit] = to.diff(from, unit)))

        return diff
    }

    let birthdayDate = null
    let age = {}

    const hasAllUnits = date =>
        dateUnits.filter(unit => !date[unit] && date[unit] !== 0).length === 0

    const dayjsUnit = unit => (unit != "day" ? unit : "date")

    const toDate = birthday => {
        let birthdayDate = dayjs().startOf("year")
        dateUnits.forEach(
            unit => (birthdayDate = birthdayDate.set(dayjsUnit(unit), birthday[unit])),
        )
        birthdayDate = birthdayDate.month(birthdayDate.month() - 1)
        return birthdayDate
    }

    onMount(() => {
        console.log("App mounted")
        console.dir(inputDom)
        console.dir(outputDom)
    })

    $: if (birthdayDate) age = difference(birthdayDate, $now)

    $: console.log("name changed to", name)

    $: {
        console.log("birthday changed to", birthday)

        if (hasAllUnits(birthday)) {
            birthdayDate = toDate(birthday)
            animateScroll.scrollToBottom()
            console.log("age changed to", age)
        } else {
            birthdayDate = null
            age = null
            console.log("age unset")
        }
    }

    console.log("App initialized")
</script>

<style>
    :global(body) {
        scroll-behavior: smooth;
    }
</style>

<Head let:class={titleSlotClass}>
    <h1 slot="title">AgeInDays</h1>
    <h2 slot="title" class={titleSlotClass}>You might be older than you think you are</h2>
    <p>Enter your information and find out your true age</p>
</Head>
<PersonDataInput bind:name bind:birthday birthdayUnits={dateUnits} bind:this={inputDom} />
<AgeOutput {name} {age} bind:this={outputDom} />
